import createReducer from "../../createReducer";
import { mailchimpConfigHandlers } from "../handlers";
import { IMailchimpConfigState } from "../types";

export const updateMailchimpConfig: IMailchimpConfigState = {
    isLoading: false,
    error: null,
    configData: {},
};
export default createReducer(updateMailchimpConfig, mailchimpConfigHandlers);
